import { graphql, useStaticQuery } from 'gatsby';

import type { Lucid } from '../types/types';

const usePathPrefix = () => {
  const { site } = useStaticQuery<Lucid.Query.Hooks.UsePathPrefix>(graphql`
    query usePathPrefixQuery {
      site {
        pathPrefix
      }
    }
  `);

  return site.pathPrefix;
};

export default usePathPrefix;
